import React from "react";

export function Badge({ children, tone = "neutral" }) {
  const map = {
    neutral: "bg-neutral-100 text-neutral-800 border-neutral-200",
    green: "bg-green-50 text-green-700 border-green-100",
    yellow: "bg-yellow-50 text-yellow-800 border-yellow-100",
    red: "bg-red-50 text-red-700 border-red-100",
    blue: "bg-blue-50 text-blue-700 border-blue-100",
  };
  return (
    <span className={`inline-flex items-center px-2 py-1 text-xs border ${map[tone] || map.neutral}`}>
      {children}
    </span>
  );
}

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const base =
    "h-10 px-4 text-sm font-medium inline-flex items-center justify-center border transition disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-neutral-900 text-white border-neutral-900 hover:bg-neutral-800",
    ghost: "bg-white text-neutral-900 border-neutral-200 hover:border-neutral-900",
    danger: "bg-red-600 text-white border-red-600 hover:bg-red-700",
  };
  return (
    <button className={`${base} ${variants[variant] || variants.primary} ${className}`} {...props}>
      {children}
    </button>
  );
}
